module.exports = __webpack_public_path__ + "img/html.0315c9b1.png";